import { B, InlineClient, InlineCompany } from "./Parts";
import { Company, Client, Quote, QuoteItem } from "../../types";
import { getAmounts, intToBrl } from "../../utils";
import moment from "moment";

const ContentRentUpdate = ({
  company,
  client,
  quote,
  equipmentMap,
}: {
  company: Company;
  client: Client;
  quote: Quote;
  equipmentMap: Record<string, string>;
}) => {
  const total = getAmounts(quote).finalRent - quote.feeMonitoring;
  return (
    <div className="tracking-tight flex flex-col gap-4 py-8 pb-32 text-justify">
      <div className="text-center font-bold uppercase">
        TERMO ADITIVO AO CONTRATO DE PRESTAÇÃO DE SERVIÇO DE LOCAÇÃO DE ALARME E
        MONITORAMENTO.
      </div>

      <div>
        Pelo presente instrumento particular, a empresa{" "}
        <InlineCompany company={company} /> e <InlineClient client={client} />,
        firmam o presente <b>Termo Aditivo</b> ao contrato de monitoramento de
        alarme, alterando as seguintes cláusulas:
      </div>

      <div>
        CLÁUSULA 1ª. – Fica estabelecida a partir de{" "}
        <b>{moment.utc().format("DD/MM/YYYY")}</b> a inclusão do (s)
        equipamentos (s) abaixo discriminado (s) como item de locação:
      </div>

      <EquipmentList
        equipments={quote.itemsRented}
        equipmentMap={equipmentMap}
      />

      <div>
        CLÁUSULA 2.ª - Será adicionado à importância paga mensalmente a
        CONTRATADA, o valor de <b>{intToBrl(total)}</b>.
      </div>

      <div>
        Ficam <b>RATIFICADOS, por meio deste, todas as demais cláusulas</b>,
        termos e condições do contrato aditado, no que pelo presente, não foram
        alterados, de forma que juntos produzam um só e mesmo efeito jurídico.
      </div>

      <div className="flex flex-col gap-4 break-inside-avoid">
        <div>
          E, por estar de acordo, assinar o presente em duas vias de igual teor
          e para o mesmo fim, na presença das testemunhas abaixo.
        </div>

        <div className="text-center my-4">
          Vitória/ES, {moment.utc().format("DD [de] MMMM [de] YYYY")}
        </div>

        <div className="text-center mt-12">
          <B>{company.name}</B>
          <div className="text-sm">(Contratada)</div>
        </div>

        <div className="text-center mt-12">
          <B>{client.name}</B>
          <div className="text-sm">(Contratante)</div>
        </div>
      </div>
    </div>
  );
};

export default ContentRentUpdate;

const EquipmentList = ({
  equipments,
  equipmentMap,
}: {
  equipments: QuoteItem[];
  equipmentMap: Record<string, string>;
}) => {
  return (
    <ul className="list-disc list-inside pl-4 leading-relaxed">
      {equipments.map((equipment, i) => (
        <li className="font-semibold" key={i}>
          {equipment.amount} × {equipmentMap[equipment.equipmentUuid]}
        </li>
      ))}
    </ul>
  );
};
